import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { SchoolCardModule } from '@app/schools/school-card/school-card.module';
import { ChangableComponent } from '@models/changable.component';
import { CSchool } from 'lingo2-models';

@Component({
  selector: 'app-school-mini',
  standalone: true,
  templateUrl: './school-mini.component.html',
  styleUrls: ['./school-mini.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LocaleSharedModule, SchoolCardModule],
})
export class SchoolMiniComponent extends ChangableComponent {
  @Input() type: 'row' | 'column';
  @Input() public set school(school: Partial<CSchool>) {
    this._school = school;
  }
  public get school(): Partial<CSchool> {
    return this._school;
  }
  @Output() clicked = new EventEmitter<Partial<CSchool>>();
  @Output() changed = new EventEmitter<boolean>();

  private _school: Partial<CSchool>;

  public onClick(event) {
    this.clicked.emit(event);
  }

  public onChange(event) {
    this.changed.emit(event);
  }

  public get design() {
    if (this.type !== 'row') {
      return 'mini';
    } else {
      return 'default';
    }
  }
}
